// Literal route segments are short lowercase words; ids, keys, tokens and signatures never are.
const ROUTE_WORD = /^(?:[a-z][a-z_-]{0,24}|v2)$/;

export function routePattern(url: string): string {
	try {
		return new URL(url).pathname
			.split('/')
			.map((segment) =>
				!segment || ROUTE_WORD.test(segment) ? segment : ':param'
			)
			.join('/');
	} catch {
		return 'invalid';
	}
}
